import React, { useState, useEffect } from "react";
import { getDashboardPerDepartment } from "../../services";
import { BarDashboard } from "../../components";

const PerDepartment = (props) => {
  const { startDate, endDate, filter, locationId } = props;

  // Function to update dashboard
  const getDashboard = () => {
    getDashboardPerDepartment(locationId, startDate, endDate, filter).then(
      (res) => {
        setData(res);
      }
    );
  };

  // Get Dashboard when mounting
  useEffect(() => {
    getDashboard();
  }, [startDate, endDate, filter]);

  // Set variables
  const [data, setData] = useState();

  // Only render dashboard if data is populated
  if (data) {
    // Create departmentlist for values in x-axis
    const departments = [];
    data.data.forEach((dep, value) => {
      departments.push(dep.x);
    });

    let format = (v) => `${parseFloat(v/1000).toFixed(2)} kg`
    if (filter == 1) format = (v) => `€${parseFloat(v).toFixed(2)}`

    return (
      <BarDashboard
        data={data.data}
        ticks={departments}
        format={format}
      />
    );
  } else {
    // TODO: Fancy CSS Loader (not MVP)
    return <div></div>;
  }
};

export default PerDepartment;
